import React from "react";
import { css } from "@emotion/react";

import Share from "./share";
import Purchase from "./purchase";
import VolumeNav from "./volumeNav";
import Recommended from "./recommended";

const actionSlide = css`
  overflow-y: auto;

  // 画面の高さが一定(大凡.inner+header+footer)以上あれば中央寄せ
  @media screen and (min-height: 640px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .inner {
    display: inline;
    width: 100%;
    height: auto;
    margin: 0 20px;

    div {
      height: auto;
    }
  }
`;

interface Props {
  comic: Comic;
}

const ActionSlide = (props: Props) => {
  const {
    rootUrl,
    slug,
    num,
    title,
    amznUrl,
    anotherEpisodeBackward,
    anotherEpisodeForward
  } = props.comic;

  const shareUrl = () => `${rootUrl}/${slug}/${num}`;

  return (
    <div css={actionSlide}>
      <div className="inner">
        <Share url={shareUrl()} text={title} />
        {amznUrl && <Purchase amznUrl={amznUrl} />}
        <VolumeNav
          slug={slug}
          anotherEpisodeBackward={anotherEpisodeBackward}
          anotherEpisodeForward={anotherEpisodeForward}
        />
        <Recommended ownSlug={slug} isIncludedOwnSlug={false} />
      </div>
    </div>
  );
};

export default ActionSlide;
